document.addEventListener("DOMContentLoaded", function () {
    const navDropdowns = document.querySelectorAll(".nav-dropdown > a");
  
    const drawerClose = document.getElementById("drawer-close");
    const drawerBack = document.getElementById("drawer-back");
  
    navDropdowns.forEach((dropdown) => {
      dropdown.addEventListener("click", function (event) {
        event.preventDefault();
        const submenu = this.nextElementSibling;
    
        const siblings = Array.from(this.parentNode.parentNode.children).filter(
          (child) => child !== this.parentNode
        );
    
        siblings.forEach((sibling) => {
          const siblingSubmenu = sibling.querySelector(".nav-submenu");
          if (siblingSubmenu) siblingSubmenu.classList.remove("active");
        });
    
        submenu.classList.add("active");
    
        drawerClose.style.display = "none";
        drawerBack.style.display = "block";
        drawerBack.textContent = submenu.querySelector(".nav-back > a").textContent;
      });
    });
    
    const navBacks = document.querySelectorAll(".nav-back > a");
  
    navBacks.forEach((back) => {
      back.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const submenu = this.closest(".nav-submenu");
        submenu.classList.remove("active");

        if (!this.closest(".nav-submenu").previousElementSibling) {
            drawerClose.style.display = "block";
            drawerBack.style.display = "none";
        }

      });
    });

    drawerBack.addEventListener("click", function () {
        const activeSubmenus = document.querySelectorAll(".nav-submenu.active");
        if (activeSubmenus.length > 0) {
            activeSubmenus[activeSubmenus.length - 1].classList.remove("active");
        }

        if (activeSubmenus.length === 1) {
            drawerClose.style.display = "block";
            drawerBack.style.display = "none";
        }

        if (activeSubmenus.length > 1) {
            drawerBack.textContent = activeSubmenus[activeSubmenus.length - 2].querySelector(".nav-back > a").textContent;
        } else {
            drawerBack.textContent = "Назад";
        }
    });
});
